// extracted by mini-css-extract-plugin
export var actionButton = "_dn-0";
export var attachmentLine = "_dn-1";
export var fileInput = "_dn-2";
export var fileUploadWrapper = "_dn-4";
export var footer = "_dn-3";
export var modalContent = "_dn-5";
export var paperclip = "_dn-6";
export var quillEditor = "_dn-7";